import React from 'react'
import './styles.css';
import DefaultResourceImage from '@BUP/assets/Images/Resources/default_resource.png';
import { Link } from 'react-router-dom';



export const HomeButton = ({ 
  linkTo = "/", 
  img, 
  buttonText = "No hay boton" 
}) => {
  return (
    <div className="home-button-wrapper">
      <Link to={linkTo}>
        <div className="home-button-content">
          <img
            src={img || DefaultResourceImage}
            alt="home-botton-img"
          />
          <button className="btn">
            {buttonText}
          </button>
        </div>
      </Link>
    </div>
  )
}